import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { usePeriod } from "backend/model/usePeriod";
import getValues from "backend/values";
import { useQuery } from "react-query";
import useModel from "../model/useModel";
import usePeriodLevels from "../model/usePeriodLevels";

import * as wf from "@qpr/client-api-workflow";

const useMyTasks = (type: "completed" | "coming", context?: string) => {
  const periods = usePeriod();
  const { data: periodLevels } = usePeriodLevels();
  const ctx = useAppContext();
  const { data: model, isLoading: isLoadingModel } = useModel();
  return useQuery(
    JSON.stringify(["data-mytasks-workflow", type, context]),
    () => {
      return wf
        .getMyTasks({ modelId: model?.[0].id || "", include: type })
        .then((taskData) => {
          console.log("taskData", taskData);
          return Promise.all(
            taskData!.map((task) => {
              return getValues(
                task.measureId,
                periods.filter((n) => n.name === ctx.period),
                true,
                periodLevels!
              ).then((list) => {
                return {
                  ...list[0],
                  workflowState: task,
                };
              });
            })
          );
        });
    },
    {
      enabled: !isLoadingModel && periods.length > 0 && !!periodLevels,
      cacheTime: context === "wfinput" ? 10 * 60 * 1000 : 20 * 1000,
      staleTime: context === "wfinput" ? 10 * 60 * 1000 : 20 * 1000,
    }
  );
};

export default useMyTasks;
